module.exports = __webpack_public_path__ + "img/logo-negativo.69cbd4a3.png";